export default "__VITE_ASSET__DBsOdrIx__"